/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 91d3a6b88c2e
 */

import { uploadMappingsCreateUploadMapping } from "../../funcs/uploadMappingsCreateUploadMapping.js";
import { UploadMappingInput$zodSchema } from "../../models/uploadmappinginput.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: UploadMappingInput$zodSchema.describe(
    `The upload mapping folder and URL template.`,
  ),
};

export const tool$uploadMappingsCreateUploadMapping: ToolDefinition<
  typeof args
> = {
  name: "create-upload-mapping",
  description: `Creates a new upload mapping

Creates a new upload mapping for the specified folder`,
  scopes: ["builder"],
  annotations: {
    "title": "Create Upload Mapping",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": false,
    "readOnlyHint": false,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await uploadMappingsCreateUploadMapping(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
